export default "__VITE_ASSET__BnU1XXc5__"